'use client'
import Image from "next/image";

  const careers = [
    {
      title: 'Star Category Hotels & Resorts',
      image: 'https://cdn.msu.edu.in/msu-lP/success-stories/building.png',
      alt: 'Modern hotel resort at dusk'
    },
    {
      title: 'Airline & Airport Hospitality',
      image: 'https://cdn.msu.edu.in/msu-lP/success-stories/frontend-receptionist.png',
      alt: 'Airport hospitality staff assisting passengers'
    },
    {
      title: 'Cruise Lines',
      image: 'https://cdn.msu.edu.in/msu-lP/success-stories/cruise.png',
      alt: 'Luxury cruise ship at sea'
    },
    {
      title: 'Luxury Malls & Real Estate Hospitality',
      image: 'https://cdn.msu.edu.in/msu-lP/success-stories/mall.png',
      alt: 'Grand luxury mall atrium'
    },
    {
      title: 'Event & Banquet Operations',
      image: 'https://cdn.msu.edu.in/msu-lP/success-stories/townhall.png',
      alt: 'Elegant banquet hall conference'
    },
    {
      title: 'Entrepreneurship in Hospitality',
      image: 'https://cdn.msu.edu.in/msu-lP/success-stories/hhm.png',
      alt: 'Entrepreneur managing hospitality business'
    }
  ];

const CareerProspects =()=> {
  return (
    <section className="bg-[#f5f5f5] max-w-(--max-page-width) mx-auto px-(--container-padding) w-full py-16 md:py-24 overflow-hidden">
      <div className="w-full mx-auto">

        <div className="text-center mb-14" >
          <p className="text-[#FFAA1A] uppercase tracking-[4px] text-sm font-semibold mb-4">
            Career Prospects
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black">
            You Can Step Into
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" >
          {careers.map((item, index) => (
            <div
              key={index}
              className="relative h-55 md:h-65 overflow-hidden rounded-2xl group"
            >
              <Image
                src={item.image}
                alt={item.title}
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
              />

              <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <h3 className="text-white text-lg md:text-xl font-semibold leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CareerProspects;